import React from 'react';
import unshackledLogo from '../../logos/unshackled_transparent.png';
import energizerLogo from '../../logos/energizer_solar.png';


function scrollToSection(sectionId) {
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  }
}


const Hero = () => {
  return (
    <section className="hero" id="home">
      <h1>AI-Powered Support for<br />Solar & Storage Systems</h1>
      <h2>Resolve your support issues 10x faster and cheaper</h2>
      <button className="ctaButton" onClick={() => scrollToSection('get-in-touch')}>Get in Touch</button>
      <div className="backedBy">
        <p>Trusted By</p>
        <img src={unshackledLogo} alt="Unshackled Ventures Logo" />
        {/* <img src={energizerLogo} alt="Energizer Logo" /> */}
      </div>
    </section>
  );
};

export default Hero;